import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { LicencaEspecialAPI } from "@/api/licencaEspecial.api";
import { AutorizacaoFretamento } from "@/models/autorizacaoFretamento";
import { Taxa } from "@/models/taxa";

const licencaEspecialAPI = new LicencaEspecialAPI();

const doLogin = (
  cnpj: string,
  recaptcha: string,
  placa: string
): AxiosObservable<any> => {
  return licencaEspecialAPI.doLogin(cnpj, recaptcha, placa);
};

const criarAutorizacaoFretamento = (
  veiculoTransportadoraId: number,
  taxaId: number
): AxiosObservable<AutorizacaoFretamento[]> => {
  return licencaEspecialAPI.criarAutorizacaoFretamento(
    veiculoTransportadoraId,
    taxaId
  );
};

const removerAutorizacaoFretamento = (
  autorizacaoFretamento: AutorizacaoFretamento
): AxiosObservable<AutorizacaoFretamento[]> => {
  return licencaEspecialAPI.removerAutorizacaoFretamento(autorizacaoFretamento);
};

const listarTodasAutorizacoesFretamento = (
  veiculoTransportadoraId: number
): AxiosObservable<AutorizacaoFretamento[]> => {
  return licencaEspecialAPI.listarTodasAutorizacoesFretamento(
    veiculoTransportadoraId
  );
};

const listarTodasTaxasFretamento = (
  veiculoTransportadoraId: number
): AxiosObservable<Taxa[]> => {
  return licencaEspecialAPI.listarTodasTaxasFretamento(veiculoTransportadoraId);
};

const imprimirLicençaViagem = (viagemId: number): AxiosObservable<any> => {
  return licencaEspecialAPI.imprimirLicençaViagem(viagemId);
};

const findAutorizacaoById = (
  id: number
): AxiosObservable<AutorizacaoFretamento> => {
  return licencaEspecialAPI.findAutorizacaoById(id);
};

export default {
  criarAutorizacaoFretamento,
  removerAutorizacaoFretamento,
  listarTodasAutorizacoesFretamento,
  listarTodasTaxasFretamento,
  imprimirLicençaViagem,
  doLogin,
  findAutorizacaoById
};
